import {CanActivateFn, UrlTree, createUrlTreeFromSnapshot, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData): Promise<boolean | UrlTree> => {
  const {authenticated} = authData; // authenticated, keycloak, grantedRoles

  if (!authenticated) {
    return Promise.resolve(true);
  }

  return Promise.resolve(createUrlTreeFromSnapshot(route, ['dashboard'], route.queryParams));
};
export const onlyGuest = createAuthGuard<CanActivateFn>(isAccessAllowed);
